import { render } from "./PublicContestListItem.vue?vue&type=template&id=5407995d&scoped=true"
import script from "./PublicContestListItem.vue?vue&type=script&lang=js"
export * from "./PublicContestListItem.vue?vue&type=script&lang=js"

import "./PublicContestListItem.vue?vue&type=style&index=0&id=5407995d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5407995d"]])

export default __exports__